import React, { useCallback, useContext } from 'react'
import { createSportsHelpers } from '../cnr/reducers/reducerHelpers/createSportsData'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { SportsSeasonContext } from '../cnr/contexts/SportsSeasonContext'
import { ammendTeamName } from '../cnr/reducers/SportsMatchReducer'
import { CreateSportsSeasonContext } from '../create/CreateSeason'

export const useCreateSchedule = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { app_state } = states ?? {}
  const { mainDb } = app_state ?? {}
  const { database_fns } = fns ?? {}

  const createSportsSeaonContext = useContext(CreateSportsSeasonContext);
  const { createSportsSeason_state } = createSportsSeaonContext ?? {}
  const { sportsSeason_selected } = createSportsSeason_state ?? {}
  const { seasonals } = sportsSeason_selected ?? {}
  const { teams: teams_season } = seasonals ?? {}

  /**
   * Test
   */
  const createSeasonMatches = useCallback(({ homeAways, sportsSeason_selected, _sportsAbr, matches_season, forceRefresh }) => {

    const _seasonMatchProps = getSeasonalMatchesProps(sportsSeason_selected, homeAways, _sportsAbr, forceRefresh)

    const {
      matches,
      seasonTeams,
      crossoverMatches
    } = createSportsHelpers.createTheSeasonMatches(database_fns, mainDb, _seasonMatchProps, matches_season)

    const mgr = _.groupBy(matches, '_matchCollectionKey')

    const seasonGridMatches = {
      matches: matches,
      crossoverMatches: crossoverMatches,
      teams: seasonTeams,
      homeAways
    }

    return seasonGridMatches

  }, []);

  const buildMatchesFromRows = useCallback(({ rows }) => {

    const dateRow = rows[1]; // row index 1 = dates
    const matches = [];

    for (let r = 2; r < rows.length; r++) {
      const row = rows[r];
      const team = row[0];

      for (let c = 1; c < row.length; c++) {
        const opponent = row[c];
        if (!opponent) continue;
        matches.push({
          homeTeam: team,
          awayTeam: opponent,
          startDate: dateRow[c] ? formatMMDDYYYY(dateRow[c]) : null,
        });
      }
    }

    return matches;

  }, []);

  const buildMatchesFull = useCallback(({ matches_parsed }) => {

    const _matches = {}
    _.forEach(matches_parsed, (match, index) => {
      const { homeTeam, awayTeam, startDate } = match
      const _homeTeam = ammendTeamName(toStartCase(homeTeam))
      const _awayTeam = ammendTeamName(toStartCase(awayTeam))
      const _home = _.find(teams_season, { name: _homeTeam })
      const _away = _.find(teams_season, { name: _awayTeam })
      if (!_.isEmpty(_home) && !_.isEmpty(_away)) {
        const mk = database_fns.get_docKey()
        _matches[mk] = {
          away: _.pick(_away, ['_itemKey', 'name', 'sections', 'levels']),
          home: _.pick(_home, ['_itemKey', 'name', 'sections', 'levels']),
          startDate,
          levels: isLevelMatch(_home, _away) ? _home.levels : 'Non',
          sections: isSectionMatch(_home, _away) ? _home.sections : 'Non',
          _matchCollectionKey: isLevelMatch(_home, _away) && isSectionMatch(_home, _away) ? _home.levels : 'Non',
          teams: [_home._itemKey, _away._itemKey],
          _created: true,
        }
      } else {
        if (!_home) { console.log('match', toStartCase(homeTeam)) }
        if (!_away) { console.log('match', toStartCase(awayTeam)) }
      }
    })
    return _matches

  }, []);

  const mergeMatches = useCallback(({ matchesExisting, matchesNew }) => {
    return merge_matches(matchesExisting, matchesNew)
  }, []);

  const mergeMatchesUnique = useCallback(({ matchesExisting, matchesNew }) => {
    return merge_matches_unique(matchesExisting, matchesNew)
  }, []);

  return {
    /**
     * Creates the matche for the season
     */
    createSeasonMatches,
    buildMatchesFromRows,
    buildMatchesFull,
    mergeMatches,
    mergeMatchesUnique
  }
}

const getSeasonalMatchesProps = (sportsSeason_selected, homeAways, _sportsAbr, forceRefresh) => {

  const { seasonals, teams_selected } = sportsSeason_selected ?? {}
  const { matches, crossSectionDates, sectionCrossovers, sectionDates, teams: teams_seasonal } = seasonals ?? {}
  const { teams } = teams_selected ?? {}

  // const _m = _.groupBy(matches, '_matchCollectionKey') 

  const _teams = teams_seasonal || teams

  const _results = {
    crossSectionDates,
    homeAways,
    matches,
    sectionCrossovers,
    sectionDates,
    teams: _teams,
  }

  const xxx = {
    gridMatches: null,
    gameScoringType: 'match',
    _sportsAbr,
    forceRefresh,
    ..._results
  }

  return xxx

}

function formatMMDDYYYY(dateStr) {
  if (!dateStr) return null;

  const [month, day, year] = dateStr.split('/');

  if (!month || !day || !year) return null;

  return [
    month.padStart(2, '0'),
    day.padStart(2, '0'),
    year
  ].join('/');
}


function toStartCase(str) {
  if (!str) return '';

  return str
    .toLowerCase()
    .split(' ')
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

const isSectionMatch = (home, away) => {
  if (home && away && (home.sections === away.sections) && (home.levels === away.levels)) {
    return true
  }
}

const isLevelMatch = (home, away) => {
  if (home && away && (home.levels === away.levels)) {
    return true
  }
}

const merge_matches = (matchesExisting = {}, matchesNew = {}) => {
  const existingMatchups = new Set(
    Object.values(matchesExisting).map(
      ({ home, away }) => `${home._itemKey}|${away._itemKey}`
    )
  )

  const matchesToAdd = {}

  _.forEach(matchesNew, (match, key) => {
    const matchupKey = `${match.home._itemKey}|${match.away._itemKey}`

    if (!existingMatchups.has(matchupKey)) {
      matchesToAdd[key] = match
      existingMatchups.add(matchupKey)
    }
  })

  return {
    ...matchesExisting,
    ...matchesToAdd
  }
}

const merge_matches_unique = (matchesExisting = {}, matchesNew = {}) => {
  const getMatchupKey = ({ home, away }) =>
    [home._itemKey, away._itemKey]
      .sort()
      .join('|')

  const existingMatchups = new Set(
    Object.values(matchesExisting).map(getMatchupKey)
  )

  const matchesToAdd = {}

  _.forEach(matchesNew, (match, key) => {
    const matchupKey = getMatchupKey(match)

    if (!existingMatchups.has(matchupKey)) {
      matchesToAdd[key] = match
      existingMatchups.add(matchupKey)
    }
  })

  return {
    ...matchesExisting,
    ...matchesToAdd
  }
}